import { createIcon } from '../icon'
import WishlistIcon from '../svg/WishlistIcon'

export const WishlistIconDefault = createIcon(WishlistIcon)
